import type { VxBadgeColor } from '@voxie/frontend-components';
import type { TermStatus } from '~/services/adminTermsClient.types';

export const termStatusLabels: Record<TermStatus, string> = {
    draft: 'Draft',
    published: 'Active',
    paused: 'Paused',
    archived: 'Archived',
};

export const termStatusColors: Record<TermStatus, VxBadgeColor> = {
    draft: 'amber',
    published: 'sky',
    paused: 'rose',
    archived: 'slate',
};

export const termStatusExplanations: Record<TermStatus, string> = {
    draft: 'Not visible to anyone yet. Fully editable.',
    published: 'Acceptance is enforced for covered groups. Locked from edits.',
    paused: 'Enforcement is suspended. Prior acceptances are preserved.',
    archived: 'No longer enforced. Read-only history.',
};
